import { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
  Box,
  Dialog,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag } from '../../../../../../src/components';
import { BASE_URL, dateFormatter, dropdownFetch, request, toast } from '../../../../../utils';
import { SalaryDetailsForm } from './SalaryDetailsForm';
import dayjs from 'dayjs';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
// import { DietManagementTable } from '../Utils/DietManagementTable';
// import { DietManagementDetailForm } from './DietManagementDetailForm';

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
const DETAIL_HEADER = [
  {
    header: 'Employee',
    accessor: (row) => `${row?.employee?.personalInfo?.firstName} ${row?.employee?.personalInfo?.lastName}`
  },
  {
    header: 'Employee ID',
    accessor: (row) => row?.employee?.workDetails?.employeeId
  },
  {
    header: 'Email',
    accessor: (row) => `${row?.employee?.personalInfo?.email}`
  },
  {
    header: 'Join Date',
    accessor: (row) => formatDate(row?.employee?.workDetails?.dateOfJoining)
  },
  {
    header: 'Role',
    accessor: (row) => row?.employee?.workDetails?.role?.name
  },
  {
    header: 'Department',
    accessor: (row) => row?.employee?.workDetails?.department?.name
  },
  {
    header: 'Salary',
    accessor: (row) => row?.netSalary
  },
  {
    header: 'Paid Amount',
    accessor: (row) => row?.paidAmount || 0
  },
  {
    header: 'Due Amount',
    accessor: (row) => row?.dueAmount
  },
];

const TODAY_IPD_DETAIL_HEADER = [
  {
    header: 'Patient Name',
    accessor: (row) => `${row.patient[0]?.name_suffix} ${row.patient[0]?.first_name} ${row.patient[0]?.last_name}`
  },
  {
    header: 'Diet Type',
    accessor: 'diet_type'
  },
  {
    header: 'Diet Details',
    accessor: 'diet_detail'
  },
  {
    header: 'Date',
    accessor: (row) => formatDate(row?.date)
  },
  {
    header: 'Time',
    accessor: 'time'
  }
];

const initialDietsDataObj = {
  data: [],
  loading: false
};

export const GenerateSalarySlip = () => {
   const { pathname } = useLocation();
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [todayIpdList, setTodayIpdList] = useState([]);
  const [currentAction, setCurrentAction] = useState();
  const [role, setRole] = useState([]);
  const [addDetailsDialogue, setAddDetailsDialogOpen] = useState(false);
  const currentYear = dayjs().year();
  const currentMonth = dayjs().month(); // 0-indexed (0 = January, 1 = February, etc.)

  // Default values
  const defaultYear = currentMonth === 0 ? currentYear - 1 : currentYear; // If it's January, set the previous year
  const defaultMonth = currentMonth === 0 ? 11 : currentMonth - 1; // If it's January, set December (11)

  const [year, setYear] = useState(defaultYear); // Set the default year
  const [month, setMonth] = useState(defaultMonth); // Set the default month

  const methods = useForm({
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0]
    },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset, watch } = methods;

  const fetchEmployeeList = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/payroll/${year}/${month + 1}`);
      if (response?.data?.success) {
        toast(`Successfully Fethed Emplyee Details`, { variant: 'success' });
        setDetailList(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      setDetailList([]);
      console.log(error.message);
      toast(`${error?.response?.data?.message ? error?.response?.data?.message : 'Something Went Wrong'}`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchEmployeeList();
  }, [month]);

  const getRoleDropdown = useCallback(async () => {
    const data = await dropdownFetch('employee-role');
    setRole(data);
  }, []);

  useEffect(() => {
    getRoleDropdown();
  }, [getRoleDropdown]);


  const handlePrintSlip=(row)=>{
    window.open(
      `/print${pathname}?refId=${JSON.stringify({
        employeeId : row._id,
      })}`,
      '_blank'
    )
  }


  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          boxSizing: 'border-box'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Employee Salary
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button onClick={() => setAddDetailsDialogOpen(true)} variant="contained">
                  Add Salary
                </Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 2 }} direction="row" spacing={2} alignItems="center">
                {/* Employee Name */}
                <Stack spacing={0.5} direction="row" sx={{ flex: 1 }}>
                  <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem', textAlign: 'center',alignContent:"center" }}>
                    Employee Name
                  </Typography>
                  <TextField
                    sx={{
                      flex: 0.75,
                      border: currentAction ? '0.5px solid red' : '',
                    }}
                    name="name"
                    placeholder="Enter Employee Name"
                  />
                </Stack>

                {/* Role */}
                <Stack spacing={0.5} direction="row" sx={{ flex: 1 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem', textAlign: 'center',alignContent:"center" }}>
                    Role
                  </Typography>
                  <SelectTag
                    sx={{
                      flex: 0.75,
                      border: currentAction ? '0.5px solid red' : ''
                    }}
                    name="role"
                    menus={role.map((data) => ({ ...data, name: data?.name }))}
                    placeholder="Select Role"
                  />
                </Stack>

                {/* Year Selector */}
                <FormControl sx={{ flex: 1 }} fullWidth>
                  <InputLabel sx={{ fontSize: '18px' }}>Year</InputLabel>
                  <Select
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    label="Year"
                    sx={{
                      fontSize: '16px',
                      fontWeight: 700,
                      '& .MuiInputLabel-root': {
                        fontSize: '18px'
                      }
                    }}
                  >
                    {Array.from({ length: 10 }, (_, index) => dayjs().year() - 5 + index).map((yearValue) => (
                      <MenuItem sx={{ fontSize: '12px', fontWeight: 700 }} key={yearValue} value={yearValue}>
                        {yearValue}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Month Selector */}
                <FormControl sx={{ flex: 1 }} fullWidth>
                  <InputLabel sx={{ fontSize: '18px' }}>Month</InputLabel>
                  <Select
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    label="Month"
                    sx={{
                      fontSize: '16px',
                      fontWeight: 700,
                      '& .MuiInputLabel-root': {
                        fontSize: '18px'
                      }
                    }}
                  >
                    {[
                      'January',
                      'February',
                      'March',
                      'April',
                      'May',
                      'June',
                      'July',
                      'August',
                      'September',
                      'October',
                      'November',
                      'December'
                    ].map((monthName, index) => (
                      <MenuItem sx={{ fontSize: '12px', fontWeight: 700 }} key={monthName} value={index}>
                        {monthName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* Search Button */}
              </Stack>

              <Grid container spacing={1}>
                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={detailList}
                    columns={DETAIL_HEADER}
                    size="small"
                    printSalary={true}
                    handlePrintSlip={handlePrintSlip}
                  />
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
        <Dialog
          open={addDetailsDialogue}
          onClose={() => setAddDetailsDialogOpen(false)}
          PaperProps={{ sx: { width: '80%', height: '80vh', p: 2 } }}
          maxWidth="xl"
          scroll="body"
        >
          <SalaryDetailsForm onClose={() => setAddDetailsDialogOpen(false)} />
        </Dialog>
      </Paper>
    </>
  );
};
